import mapProjects from './map-projects';

export {
  mapProjects,
}
